<div ng-controller="NumberSequenceController as numSeqEditCtrl" class="modal-view ">
    <c-auto-form config="numSeqEditCtrl.sheetProps"></c-auto-form>
</div>